import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';

const CATEGORIES = [
    { id: 'all', label: 'Tous les produits', icon: 'solar:widget-bold-duotone' },
    { id: 'informatique', label: 'Informatique', icon: 'solar:cpu-bolt-bold-duotone' },
    { id: 'maison', label: 'Maison', icon: 'solar:home-smile-bold-duotone' },
];

const SORT_OPTIONS = [
    { value: 'default', label: 'Par défaut' },
    { value: 'price-asc', label: 'Prix croissant' },
    { value: 'price-desc', label: 'Prix décroissant' },
    { value: 'rating', label: 'Mieux notés' },
];

const FilterBar = ({ activeCategory, onCategoryChange, sortValue, onSortChange, total }) => {
    const [sortOpen, setSortOpen] = useState(false);

    return (
        <motion.div
            className="sticky top-10 z-[100] bg-white/80 dark:bg-store-dark/90 backdrop-blur-xl border-b border-slate-200 dark:border-store-border px-4 py-3 transition-colors duration-300"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
        >
            <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-3">
                {/* Category tabs */}
                <div className="flex items-center gap-2 flex-wrap">
                    {CATEGORIES.map((cat) => (
                        <motion.button
                            key={cat.id}
                            onClick={() => onCategoryChange(cat.id)}
                            whileTap={{ scale: 0.95 }}
                            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200 ${activeCategory === cat.id
                                ? 'bg-lime-500 text-black shadow-[0_0_12px_rgba(163,230,53,0.4)]'
                                : 'bg-slate-100 dark:bg-store-gray-dark/50 text-slate-600 dark:text-store-gray hover:text-slate-900 dark:hover:text-white hover:bg-slate-200 dark:hover:bg-store-gray-dark border border-slate-200 dark:border-store-border'
                                }`}
                        >
                            <Icon icon={cat.icon} className="text-base" />
                            {cat.label}
                        </motion.button>
                    ))}
                </div>

                {/* Right side: count + sort */}
                <div className="flex items-center gap-3">
                    <span className="text-slate-500 dark:text-store-gray text-xs font-medium">
                        <span className="text-lime-600 dark:text-lime-400 font-bold">{total}</span> produit{total > 1 ? 's' : ''}
                    </span>

                    {/* Sort dropdown */}
                    <div className="relative">
                        <button
                            onClick={() => setSortOpen((v) => !v)}
                            className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 dark:bg-store-gray-dark/50 border border-slate-200 dark:border-store-border rounded-lg text-xs text-slate-600 dark:text-store-gray hover:text-slate-900 dark:hover:text-white transition-colors"
                        >
                            <Icon icon="solar:sort-bold" className="text-base text-lime-600 dark:text-lime-400" />
                            {SORT_OPTIONS.find((o) => o.value === sortValue)?.label || 'Trier'}
                            <Icon
                                icon="solar:alt-arrow-down-bold"
                                className={`text-xs transition-transform ${sortOpen ? 'rotate-180' : ''}`}
                            />
                        </button>

                        {sortOpen && (
                            <motion.div
                                initial={{ opacity: 0, y: -6, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                className="absolute right-0 mt-1 w-44 bg-white dark:bg-store-dark border border-slate-200 dark:border-store-border rounded-xl shadow-2xl z-30 overflow-hidden"
                            >
                                {SORT_OPTIONS.map((opt) => (
                                    <button
                                        key={opt.value}
                                        onClick={() => {
                                            onSortChange(opt.value);
                                            setSortOpen(false);
                                        }}
                                        className={`w-full text-left px-4 py-2.5 text-xs transition-colors ${sortValue === opt.value
                                            ? 'text-lime-600 dark:text-lime-400 bg-lime-500/10'
                                            : 'text-slate-600 dark:text-store-gray hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-store-gray-dark/50'
                                            }`}
                                    >
                                        {opt.label}
                                    </button>
                                ))}
                            </motion.div>
                        )}
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default FilterBar;
